import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  children?: ReactNode;
}

export default function EmptyState({
  icon = 'ri-search-eye-line',
  title,
  description,
  actionLabel,
  onAction,
  children,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <i className={`${icon} text-3xl`} aria-hidden="true" />
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600 leading-relaxed">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 h-10 px-4 rounded-md bg-primary-500 font-label text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" aria-hidden="true" />
          {actionLabel}
        </button>
      )}
      {children}
    </div>
  );
}